module.exports = __webpack_public_path__ + "static/media/add candidate info.8a2645f0.svg";